/* PALM-001-DI */
function customersHomesIsMobileSafariWebKit() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPod|iPad/i.test(ua)) return true;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  return false;
}

function customersHomesPrimeVideoFrame(video) {
  if (!video || video.dataset.chPrimeDone === '1') return;
  const card = video.closest('[data-customers-homes-card]');
  if (!card || card.querySelector('[data-customers-homes-poster]')) return;

  const apply = () => {
    try {
      video.muted = true;
      if (video.readyState >= 2 && video.duration && Number.isFinite(video.duration)) {
        const t = Math.min(0.06, Math.max(0.001, video.duration * 0.003));
        video.currentTime = t;
        video.addEventListener(
          'seeked',
          () => {
            try {
              video.pause();
              video.currentTime = 0;
            } catch (e) {}
          },
          { once: true }
        );
      }
    } catch (e) {}
    video.dataset.chPrimeDone = '1';
  };

  if (video.readyState >= 2) apply();
  else video.addEventListener('loadeddata', apply, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-customers-homes-root]').forEach((root) => {
    const track = root.querySelector('[data-customers-homes-track]');
    const thumb = root.querySelector('[data-customers-homes-thumb]');
    const mq = window.matchMedia('(max-width: 749px)');

    if (customersHomesIsMobileSafariWebKit()) {
      root.querySelectorAll('.customers-homes__video').forEach((video) => {
        customersHomesPrimeVideoFrame(video);
      });
    }

    function syncThumb() {
      if (!track || !thumb || !mq.matches) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }
      const ratio = track.clientWidth / track.scrollWidth;
      const thumbWidth = Math.max(48, Math.round(track.clientWidth * ratio));
      thumb.style.width = `${thumbWidth}px`;
      const scrollRatio = track.scrollLeft / maxScroll;
      const travel = track.clientWidth - thumbWidth;
      thumb.style.transform = `translateX(${Math.round(scrollRatio * travel)}px)`;
    }

    function resetCustomerVideoCard(card) {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('[data-customers-homes-play]');
      const replayBtn = card.querySelector('[data-customers-homes-replay]');
      if (!video) return;
      video.pause();
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      playBtn?.classList.add('is-hidden');
      replayBtn?.classList.remove('is-hidden');
      card.classList.remove('customers-homes__card--playing');
      card.classList.add('customers-homes__card--ended');
    }

    function startCustomerVideo(card) {
      const video = card.querySelector('video');
      const poster = card.querySelector('[data-customers-homes-poster]');
      const playBtn = card.querySelector('[data-customers-homes-play]');
      const replayBtn = card.querySelector('[data-customers-homes-replay]');
      if (!video) return;
      poster?.classList.add('is-hidden');
      playBtn?.classList.add('is-hidden');
      replayBtn?.classList.add('is-hidden');
      card.classList.remove('customers-homes__card--ended');
      card.classList.add('customers-homes__card--playing');
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    root.querySelectorAll('.customers-homes__video').forEach((video) => {
      video.addEventListener('ended', () => {
        const card = video.closest('[data-customers-homes-card]');
        if (card) resetCustomerVideoCard(card);
      });
    });

    root.querySelectorAll('[data-customers-homes-play]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-customers-homes-card]');
        if (card) startCustomerVideo(card);
      });
    });

    root.querySelectorAll('[data-customers-homes-replay]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-customers-homes-card]');
        if (card) startCustomerVideo(card);
      });
    });

    if (track && thumb) {
      track.addEventListener('scroll', syncThumb, { passive: true });
      window.addEventListener('resize', syncThumb);
      mq.addEventListener('change', syncThumb);
      syncThumb();
    }
  });
});
